"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PromoControlsWrapper = void 0;
var React = _interopRequireWildcard(require("react"));
var style = _interopRequireWildcard(require("./PromoControlsWrapper.css"));
var _Controls = require("../../../PromoModal/parts/Controls");
var _uiKit = require("@cian/ui-kit");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const PromoControlsWrapper = props => {
  const {
    onBackButtonClick,
    children,
    description
  } = props;
  const deviceType = (0, _uiKit.useDeviceType)();
  const descriptionTextAlign = deviceType === 'phone' ? 'center' : 'right';
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_uiKit.Responsive, {
    desktop: true,
    tablet: true
  }, /*#__PURE__*/React.createElement("div", {
    className: style['wrapper']
  }, /*#__PURE__*/React.createElement(_uiKit.ActionLink, {
    onClick: onBackButtonClick,
    fontWeight: "bold"
  }, "\u041D\u0430\u0437\u0430\u0434"), /*#__PURE__*/React.createElement(_Controls.Controls, null, children))), /*#__PURE__*/React.createElement(_uiKit.Responsive, {
    phone: true
  }, children), description && /*#__PURE__*/React.createElement("div", {
    className: style['description']
  }, /*#__PURE__*/React.createElement(_uiKit.UIText3, {
    color: "text-secondary-default",
    textAlign: descriptionTextAlign
  }, description)));
};
exports.PromoControlsWrapper = PromoControlsWrapper;